import axios from "axios";

// Updated for Vite's environment variable syntax
const BASE = import.meta.env.VITE_BACKEND_URL;
export const API = `${BASE}/api`;

export const http = axios.create({ baseURL: API });

export const uploadCsv = (file, fileDate) => {
  const fd = new FormData();
  fd.append("file", file);
  if (fileDate) fd.append("file_date", fileDate);
  return http.post("/upload-csv", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadConstituents = (indexName, file) => {
  const fd = new FormData();
  fd.append("index_name", indexName);
  fd.append("file", file);
  return http.post("/upload-index-constituents", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const fetchIndices = () => http.get("/indices");
export const fetchConstituentGroups = () => http.get("/index-constituents");
export const fetchConstituents = (idx) =>
  http.get(`/index-constituents/${encodeURIComponent(idx)}`);
export const fetchStocks = () => http.get("/stocks");
export const fetchLatestSnapshot = (payload) => {
  // Backward compatible: accepts either a plain array of symbols (legacy
  // call sites) or a payload object like { symbols } / { indices } / both --
  // indices lets the backend expand a whole index's constituents server-side
  // instead of the caller sending hundreds of individual stock symbols.
  const body = Array.isArray(payload) ? { symbols: payload } : payload;
  return http.post("/latest-snapshot", body);
};
export const fetchStockPrices = (symbol, isIndex = false) =>
  http.get(`/stock-prices/${encodeURIComponent(symbol)}`, {
    params: { is_index: isIndex },
  });
export const computeRrg = (payload) => http.post("/rrg", payload);
export const customIndicators = (payload) =>
  http.post("/indicators/custom", payload);

// CORRECTED: Using 'http.post' and removed '/api' from the path
export const autoFetchBhavcopy = async (start_date, end_date) => {
  return await http.post("/fetch-nse-bhavcopy", {
    start_date,
    end_date,
    date: (!start_date && !end_date) ? new Date().toISOString().split('T')[0] : null
  });
};

export const autoFetchIndices = async () => await http.post("/auto-fetch-constituents");